(function ($) {

    this.init = function () {
        this.CommunityBand();
    };

    this.CommunityBand = function () {

        var $counter = $(".counter"),
            counterArray = [];

        $counter.each(function () {
            var $this = $(this);

            counterArray.push(new Odometer({
                el: this,
                value: $this.data("start"),
                endValue: $this.data("end"),
                format: $this.data("format"),
                duration: 2500
            }));

            if (counterArray.length > 0) {
                $(window).bind("load scroll", function () {
                    if ($(window).scrollTop() > $counter.offset().top - $(window).height()) {
                        $.each(counterArray, function () {
                            this.update(this.options.endValue);
                        });
                    }
                });
            }
        });

    }

    this.init();

})(jQuery);

